import {
  Radio as MantineRadio,
  RadioIndicatorProps as MantineRadioIndicatorProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './RadioIndicator.module.css';

export type RadioIndicatorProps = Omit<
  MantineRadioIndicatorProps,
  'variant' | 'color' | 'styles' | 'classNames' | 'style' | 'size'
>;

export const RadioIndicator = forwardRef<HTMLDivElement, RadioIndicatorProps>(
  ({ ...props }, ref) => {
    return (
      <MantineRadio.Indicator
        ref={ref}
        unstyled
        className={styles.indicator}
        classNames={{
          indicator: styles.indicator,
          icon: styles.icon,
        }}
        {...props}
      />
    );
  }
);

RadioIndicator.displayName = 'RadioIndicator';
